import React from 'react'
import {
  TheContent,
  TheSidebar,
  TheFooter,
  TheHeader
} from './index'  
import { useSelector} from 'react-redux'
const TheLayout = () => {
  const show = useSelector(state => state.vals)
  const loader= ()=>{  

    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
      }}>
    
      
            </div>
    
    );
    
      }

  return (
    <div className="c-app c-default-layout">
       
      <TheSidebar/>
      <div className="c-wrapper">
        <TheHeader/>
    

        <div className="c-body">
           {show?loader(): <TheContent/>  }
        </div>
        <TheFooter/>
      </div>
    </div>
  )
}

export default TheLayout
